import React, { Component } from 'react';
import { connect } from 'react-redux';

import Dim from 'web/components/common/modal/common/Dim';
import MarketingAgree from 'web/components/common/modal/MarketingAgree';

import {
  postMarketingRequest,
  postMarketingFailure,
} from 'shared/actions/auth.action';

@connect(null, {
  agree: postMarketingRequest,
  disagree: postMarketingFailure,
})
class MarketingAgreeContainer extends Component {
  agree = e => {
    this.props.agree(true);
    this.props.popupHandler.close();
  };
  disagree = e => {
    // 요청을 보내지 않고 failure 액션으로 처리
    this.props.disagree();
    this.props.popupHandler.close();
  };

  render() {
    return (
      <Dim>
        <MarketingAgree agree={this.agree} disagree={this.disagree} />
      </Dim>
    );
  }
}

export default MarketingAgreeContainer;
